import { render, staticRenderFns } from "./EventStatusWidget.vue?vue&type=template&id=7c844d00&scoped=true&"
import script from "./EventStatusWidget.vue?vue&type=script&lang=js&"
export * from "./EventStatusWidget.vue?vue&type=script&lang=js&"
import style0 from "./EventStatusWidget.vue?vue&type=style&index=0&id=7c844d00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c844d00",
  null
  
)

export default component.exports